import { useEffect, useRef, useState } from "react";

/**
 * Measures the controls bar height and exposes inline style + ref
 * so content padding matches the real height of the bottom controls.
 */
export const usePatientWidgetControlsOffset = (extraPadding = 22) => {
  const controlsRef = useRef(null);
  const [offset, setOffset] = useState(null);

  useEffect(() => {
    if (!controlsRef.current || typeof ResizeObserver === "undefined") return;

    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      const height = entry?.contentRect?.height || 0;
      setOffset(height + extraPadding);
    });

    observer.observe(controlsRef.current);
    return () => observer.disconnect();
  }, [extraPadding]);

  const shellStyle = offset
    ? { "--patient-widget-controls-offset": `${offset}px` }
    : {};

  return { controlsRef, shellStyle };
};

export default usePatientWidgetControlsOffset;
